module.exports = __webpack_public_path__ + "static/img/infrared.bea643af.png";